const ROLES = {
  ROLE_ADMIN: 'ADMIN',
  ROLE_PARTNER_ADMIN: 'PARTNER',
  ROLE_MOTORISTA: 'DRIVER',
  ROLE_RECOLHA: 'WAREHOUSE',
  ROLE_DEDICATED_CAR: 'CAR_DEDICATED'
}

export default ROLES



// WEBPACK FOOTER //
// ./src/roles/index.js